/**
 * @generated SignedSource<<a94a56c98bb49efc4fff62fdf2dcf8bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StorecastShowFileFocusClearFilePageMutation$variables = {
  storecastId: string;
};
export type StorecastShowFileFocusClearFilePageMutation$data = {
  readonly dashboard: {
    readonly endFocus: {
      readonly focusedNodeId: string | null;
    };
  };
};
export type StorecastShowFileFocusClearFilePageMutation = {
  response: StorecastShowFileFocusClearFilePageMutation$data;
  variables: StorecastShowFileFocusClearFilePageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storecastId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "dashboardId",
    "variableName": "storecastId"
  }
],
v2 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "focusedNodeId",
      "storageKey": null
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StorecastShowFileFocusClearFilePageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DashboardMutation",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Dashboard",
            "kind": "LinkedField",
            "name": "endFocus",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StorecastShowFileFocusClearFilePageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DashboardMutation",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Dashboard",
            "kind": "LinkedField",
            "name": "endFocus",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "70103aba753bbcf504c3e99536e51af8",
    "id": null,
    "metadata": {},
    "name": "StorecastShowFileFocusClearFilePageMutation",
    "operationKind": "mutation",
    "text": "mutation StorecastShowFileFocusClearFilePageMutation(\n  $storecastId: ID!\n) {\n  dashboard(dashboardId: $storecastId) {\n    endFocus {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3d2fac3851c05cda77856dece8e56ecd";

export default node;
